export default {
    login: {
        first: 'Wir erstellen',
        second: 'Sensorlösungen für Sie.',
        third: 'Unser einfaches, aber intelligentes Design bietet Ihnen die Tools, um Echtzeitdaten in sofort verbesserte Geschäftsleistung umzuwandeln.',
        desc: 'Melden Sie sich an, indem Sie unten Informationen eingeben',
        username: 'Nutzername',
        password: 'Passwort',
        successful: 'Anmeldung erfolgreich',
        logout: 'Ausloggen',
        log: 'Anmeldung',
        in: '',
    },
    dashboard: {
        title: 'Instrumententafel',
        search: 'Suchen',
        nav: {
            type: 'Art',
            location: 'Ort',
            batch: 'Kalibrierung',
            remark: 'Anmerkung',
            lqi: 'Verbindungslink',
            lqi_hover: 'Verbindungsqualitätsindikator',
            unit: 'Einheit',
            frame_update: 'Einstellungen gesendet',
            l_update: 'Letzte Daten',
            timing: 'Dynamisches Timing',
            sensing: 'Dynamische Erfassung',
            notification: 'Benachrichtigung',
            favourite: 'Lieblings',
        },
        bulk_setup: {
            substrate_properties: 'Substrateigenschaften',
            frame_selection: 'Rahmenauswahl',
            critical_value: 'Benachrichtigungsschwellen',
            payload_error: 'Das Nutzdatenformat ausgewählter Geräte ist nicht identisch',
            batch_type_error: 'Die Art der Gerätestapel ist nicht identisch (Eigenschaften deaktiviert)',
            batch_missing_error: 'Ein oder mehrere Tentakelstapel sind nicht festgelegt (Eigenschaften deaktiviert)',
            batch_all_error: 'Um fortzufahren, stellen Sie bitte alle Eigenschaften ein',
        },
        remark: {
            double_click: 'Doppelklicken Sie',
            to_add: 'um einen Mehrwert zu erzielen',
        },
    },
    map: {
        calculated: 'Berechneter Standort',
        manual: 'Manuelle Platzierung',
    },
    detail: {
        new_calib_point: 'Neuen Kalibrierungspunkt hinzufügen',
        remove_calib_point: 'Kalibrierpunkt entfernen',
        raw_value: 'Rohwert',
        calibrate_min: 'Kalibrieren min.',
        calibrate_max: 'Kalibrieren Sie max.',
        apply_calib: 'Wenden Sie die Kalibrierung auf die Eigenschaften an',
        reset_minmax: 'Min und Max-Werte zurücksetzen',
        reset_calib: 'Auf Chargenkalibrierung zurücksetzen',
        select_props: 'Bitte wählen Sie die zu kalibrierenden Eigenschaften aus',
        save_props: 'In ausgewählten Eigenschaften speichern',
        percent: 'VWG',
        batch: 'Charge',
        selected_batch: 'Ausgewählte Charge',
        raw: 'Raw',
        warning: 'Warnung',
        warning_vwc: 'Der Wert für VWG oder das RAW-Äquivalent ist ungültig. Bitte korrigieren Sie die Werte so, dass sie mehr als minimal, kleiner als maximal oder ein anderer nicht vorhandener Wert sind.',
        measured_min: 'Gemessenes Minimum',
        measured_max: 'Gemessene Maximal',
        lqi: 'Verbindungsqualität',
        lqi_calculated: 'Berechnet mit Basisstationen.',
        map: 'Sensorposition',
        sensor_setting: 'Sensoreinstellungen',
        etentacles_setting: 'iTentacles-Einstellungen',
        min_value: 'Min. Wert',
        last_value: 'Letzter Wert',
        max_value: 'Maximaler Wert',
        select_data: 'Daten auswählen',
        missing: 'Keine Daten verfügbar',
        moisture_calibration: 'VWG-Kalibrierung',
        warning_batch_calibration: 'Warnung! Sie kalibrieren eine Charge',
        warning_device_calibration2: 'Warnung! Um die Kalibrierung auf Eigenschaften anzuwenden, klicken Sie auf "Wenden Sie die Kalibrierung auf die Eigenschaften an"',
        device_only_label: 'Nur für das Gerät kalibrieren',
        payload_format: 'Messnutzlastrahmen (Gerät)',
        payload_format_change: 'Messnutzlastrahmen ändern',
        payload_format_not_set: 'Noch nicht aktualisiert',
        payload_format_changed: 'Letzte Bearbeitung',
        payload_format_updated: 'Letzte Aktualisierung',
        format: 'Rahmen',
        set_format: 'Rahmen einstellen',

        dynamic_sensing: 'Dynamische Erfassung',
        measurement_frame: 'Messrahmen',
        none: 'Keiner',
        moisture: 'Feuchtigkeit',
        temperature: 'Temperatur',
        light: 'Licht',
        measurement_sets: 'Akkumulierte Messsätze',
        measurement_interval: 'Messintervall',
        downlik_period: 'Downlink-Zeitraum',
        downlink_retries: 'Downlink-Wiederholungen',
        transmitting_power: 'Sendeleistung',
        message_interval: 'Nachrichtenintervall',
        device_lifespan: 'Lebensdauer des Geräts',
        once_per_four: 'Einmal pro 4 Tage',
        once_per_two: 'Einmal pro 2 Tage',
        once_per_day: 'Einmal am Tag',
        twice_per_day: 'Zweimal am Tag',
        set_dynamic_sensing: 'Stellen Sie die dynamische Erfassung ein'
    },
    lqi: {
        Excellent: 'Ausgezeichnet',
        Good: 'Gut',
        Average: 'Durchschnittlich',
        Limit: 'Begrenzt'
    },
    server_status: {
        title: 'Server Status',
    },
    privacy: {
        title: 'Datenschutz-Bestimmungen',
    },
    sigfox_coverage: {
        title: 'Sigfox-Abdeckung',
        coverage_error: 'Sigfox Coverage Service-Fehler',
        unstable: 'Es gibt keine Abdeckung und das Gerät wird möglicherweise nicht synchronisiert.',
        works_underground: 'Die Verbindung ist stark und das Gerät sollte unterirdisch oder tief in Innenräumen funktionieren.',
        possible_underground: 'Die Verbindung ist stark genug, um unterirdisch oder tief drinnen arbeiten zu können.',
        works_indoor: 'Die Verbindung ist stabil und das Gerät sollte in Innenräumen funktionieren (möglicherweise nicht im Untergrund).',
        possible_indoor: 'Die Verbindung ist stabil genug für die Möglichkeit, in Innenräumen zu arbeiten. (funktioniert möglicherweise nicht im Untergrund).',
        works_open: 'Die Verbindung ist möglicherweise nicht stabil und das Gerät sollte auf offenem Feld funktionieren.',
        possible_open: 'Das Gerät hat eine Verbindung und es besteht die Möglichkeit, dass das Gerät auf offenem Feld funktioniert.',
    },
    payload: {
        title: 'Soil 3XS Nutzlast',
    },
    export: {
        limit: 'Wählen Sie die letzten x-Werte aus ausgewählten Tentakeln aus',
        info: {
            first: 'Export',
            second: 'ausgewählt',
            rest: 'Wählen Sie zunächst einige Einheiten aus der Tabelle aus',
        },
        tabs: {
            date_range: 'Datumsbereich',
            limit_values: 'Grenzwerte',
        },
    },
    contact_us: {
        title: 'Kontaktiere uns',
        subj: 'Gegenstand',
        mess: 'Botschaft',
    },
    tooltips: {
        customer: 'Anzeigen von Geräten, die diesem Kunden zugeordnet sind',
        logout: 'Ausloggen',
        total_units: 'Gesamteinheiten',
        unit_name: 'Einheitenname',
        excel: 'In Excel-Datei exportieren',
        csv: 'In CSV exportieren',
        search: 'oder drücken Sie',
        tentacle_missing: 'Wähle mindestens einen Tentakel',
    },
    buttons: {
        ok: 'Ok',
        login: 'Anmeldung',
        detail: 'Detail',
        apply: 'Änderungen übernehmen',
        apply_range: 'Bereich anwenden',
        bulk: 'Bulk-Setup',
        bulkdetail: 'Massendetail',
        cancel: 'Stornieren',
        send: 'Senden',
        export: 'Export',
        delete_range: 'Bereich löschen',
        next: 'Nächster',
        previous: 'Zurück',
        save: 'Sparen',
    },
    metrics: {
        moisture: 'VWG',
        light: 'Licht',
        temperature: 'Temperatur',
        battery: 'Batterie',
        pH: 'pH',
        ph: 'pH',
        pump_mode: 'Pumpe läuft',
        pressure: 'Druck',
        gyroscope: 'Vibrationen',
        events: 'Veranstaltungen',
        currents: 'Phasenstrom',
        angles: 'Phasenwinkel',
        over_vibration_stop: 'Überschwingungsstopp',
    },
    timing: {
        t1: '15 Minuten',
        t2: '30 Minuten',
        t3: '1 Stunde',
        t4: '2 std',
        t5: '8 std',
        t6: 'Ausschalten',
    },
    interval: {
        day: 'für einen tag',
        week: 'für eine Woche',
        month: 'für Monat',
        year: 'für Jahr',
    },
    notifications: {
        sms: 'SMS',
        email: 'E-Mail',
        push: 'Push-Benachrichtigung',
    },
    sensing: {
        sens1: 'Current Soil 3XT-4',
        sens2: 'Original 2x per hour',
        sens3: 'Moisture 4x per hour',
        sens4: 'Moisture 3x per 45 min',
        sens5: 'Moisture/Temp 2x per 30 min',
        sens6: 'Moisture/Temp/Light 2x per 30 min',
    },
    info: {
        loading_data: 'Lade Daten'
    },
};
